import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';

const FaqPage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t('faq.pageTitle')}>
      <div className="o-retain o-retain--lap u-margin-top-huge u-margin-bottom-huge">
        <h1>{t('faq.pageHeading')}</h1>
        <p>
          Wij zijn deBanenSite.nl: hét vacatureplatform met vacatures van alleen
          directe werkgevers!
        </p>

        <h3>
          <strong>
            <a href="#je-gegevens">Vragen over je gegevens beheren</a>
          </strong>
        </h3>
        <h3>
          <strong>
            <a href="#je-cv">Vragen over je cv</a>
          </strong>
        </h3>
        <h3>
          <strong>
            <a href="#account-verwijderen">Vragen over account verwijderen</a>
          </strong>
        </h3>
        <h3>
          <strong>
            <a href="#e-mailalerts">Vragen over e-mailalerts</a>
          </strong>
        </h3>
        <h3>
          <strong>
            <a href="#vacatures">Vragen over vacatures</a>
          </strong>
        </h3>
        <h3>
          <strong>
            <a href="#solliciteren">Vragen over solliciteren</a>
          </strong>
        </h3>
        <p>
          Heb je een specifieke vraag, suggesties of opmerkingen waarmee wij
          onze dienstverlening kunnen verbeteren?&nbsp;Stuur dan een email naar:{' '}
          <a href="mailto:review@debanensite.nl">review@debanensite.nl</a>.
        </p>

        <div>
          <h2 id="je-gegevens">Vragen over je gegevens beheren</h2>
          <div>
            <div>
              <p>
                Via deBanenSite.nl kun je gemakkelijk een account aanmaken. Dit
                doe je door naar deBanenSite.nl te gaan en rechtsboven op de
                groene button 'Inloggen' te klikken. Kies voor 'Werkzoekenden'
                en registreer met een e-mailadres, wachtwoord en cv. Als je
                inlogt op je profiel, kun je jouw gegevens, cv, e-mailalerts,
                sollicitaties, favoriete vacatures en privacy beheren.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h4>
            <strong>debanensite inloggen of Wachtwoord vergeten?</strong>
          </h4>
          <div>
            <div>
              <p>
                Klik op de button ‘inloggen’ rechtsboven op deBanenSite.nl en
                klik op ‘werkzoekenden’. Klik op&nbsp; ‘wachtwoord vergeten?’,
                vul je e-mailadres in en klik op ‘verstuur’. Je wachtwoord wordt
                nu naar het e-mailadres verstuurd.&nbsp;
              </p>
            </div>
          </div>
        </div>

        <div>
          <h4>
            <strong>
              Hoe kan ik mijn persoonlijke gegevens en inloggegevens aanpassen?
            </strong>
          </h4>
          <div>
            <div>
              <p>
                Log in met je e-mailadres en wachtwoord op deBanenSite.nl en
                klik in het linkermenu op de button ‘gegevens‘. Hier kun je je
                naam, woonplaats, telefoonnummer en inloggegevens
                wijzigen.&nbsp;
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2 id="je-cv">Vragen over je cv</h2>
          <div>
            <div>
              <p>
                Waar vind ik mijn cv? Je gegevens worden opgeslagen binnen de
                beveiligde omgeving van deBanenSite.nl. Dit herken je aan het
                slotje in de URL-balk. Als je inlogt op deBanenSite.nl met je
                profiel (zie hierboven), klik je in het linkermenu op de button
                'cv'. Hiermee kun je een nieuw cv uploaden.&nbsp;Cv verwijderen?
                Stuur een email naar{' '}
                <a href="mailto:info@debanensite.nl">info@debanensite.nl</a>.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h4>
            <strong>Hoe kan ik mijn cv aanpassen?</strong>
          </h4>
          <div>
            <div>
              <p>
                Log in met je e-mailadres en wachtwoord op deBanenSite.nl en
                klik in het linkermenu op de button ‘cv.’ Hier kun je je nieuwe
                cv uploaden, je gewenste functie invullen en een omschrijving
                toevoegen. Hiermee maak je jezelf aantrekkelijker voor
                potentiële werkgevers.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2 id="account-verwijderen">Vragen over account verwijderen</h2>
          <div>
            <div>
              <p>
                Je gegevens zijn opgeslagen binnen de beveiligde omgeving van
                deBanenSite.nl.&nbsp;
              </p>
              <p>
                <strong>Hoe deBanenSite.nl account verwijderen?</strong>
              </p>
              <p>
                deBanenSite.nl account verwijderen gaat snel en gemakkelijk!
              </p>
              <p>
                Als je inlogt op je profiel kun je jouw gegevens zelf
                verwijderen:
              </p>
              <ul>
                <li>Alle emailalerts</li>
                <li>Alleen CV verwijderen</li>
                <li>Alle gegevens verwijderen incl. account</li>
              </ul>
              <p>
                Selecteer de gewenste opties en klik opslaan. Als het hele
                account verwijderd wordt, zal je direct uitgelogd zijn. Hulp
                nodig? Stuur een email naar info@debanensite.nl, geef hierin aan
                je naam (voor en achternaam) / gebruikersnaam, e-mail adres en
                welke gegevens je verwijderd wil hebben dan verwijderen wij de
                gevraagde gegevens. Gegevens worden vervolgens handmatig
                verwijderd binnen 5 werkdagen.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h2 id="e-mailalerts">Vragen over e-mailalerts</h2>
          <div>
            <div>
              <p>
                Via deBanenSite.nl blijf je op de hoogte van nieuwe vacatures
                bij werkgevers. Het aanmaken van een e-mailalert gaat
                gemakkelijk. Voer een zoekopdracht in en klik vervolgens op
                'Zoeken'. Je ziet vervolgens alle zoekresultaten. Rechtsboven
                staat de button 'Alert instellen'. Hierdoor krijg je automatisch
                alle nieuwe vacatures die voldoen aan jouw zoekopdracht in je
                inbox.&nbsp;
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>
            <strong>
              Kan ik een e-mailalert uitzetten, toevoegen of aanpassen?
            </strong>
          </h4>
          <div>
            <div>
              <p>
                Dat kan door in te loggen met je e-mailadres en wachtwoord op
                deBanenSite.nl. Klik in het linkermenu op de button ‘E-mail
                alerts’ en je ziet welk e-mailalert actief is. Je kunt deze
                uitzetten of bewerken door op te klikken op ‘E-mail alert
                verwijderen’ of ‘bewerken’. ‘Nieuwe alert aanmaken’ zorgt ervoor
                dat je een extra alert activeert.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h4>
            <strong>
              Ik heb een actieve e-mailalert, maar ontvang geen vacatures
            </strong>
          </h4>
          <div>
            <div>
              <p>
                Dat komt omdat je alleen e-mails ontvangt als er een vacature
                aan jouw zoekopdracht voldoet. Krijg je geen e-mail, dan zijn er
                dus geen nieuwe vacatures geplaatst die aansluiten bij jouw
                zoekopdracht.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2 id="vacatures">Vragen over vacatures</h2>
          <div>
            <div>
              <p>
                Door op functietitel en standplaats te zoeken, vind je snel een
                passende vacature. Krijg je te veel resultaten? Via het filter
                in het zoekresultaten overzicht kun je de zoekcriteria
                aanpassen.&nbsp;Vacatures staan standaard maximaal 90 dagen
                online, probeer dus zo snel mogelijk te reageren. Als de
                vacature is vervuld gaat deze direct offline en kun je niet meer
                reageren. Als je een vacature wilt opslaan om op een later
                moment te reageren, klik je op de vacature en kies je in het
                rechtermenu voor 'Vacature opslaan'.&nbsp;
              </p>
            </div>
          </div>
        </div>

        <div>
          <h4>
            <strong>
              Waar vind ik mijn favoriete/opgeslagen vacatures terug?
            </strong>
          </h4>
          <div>
            <div>
              <p>
                Log in met je e-mailadres en wachtwoord op deBanenSite.nl en
                klik in het linkermenu op de button ‘favorieten’. Hier zie je je
                favoriete en laatst bekeken vacatures terug.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2 id="solliciteren">Vragen over solliciteren</h2>
          <div>
            <div>
              <p>
                Solliciteer snel en eenvoudig op vacatures bij directe
                werkgevers. Hoe reageer je? Klik op de button 'Solliciteer
                direct' onder de vacature. Vervolgens voeg je jouw cv en
                motivatie toe en klik je op 'Verzenden'. Reageren via
                smartphone? Dat kan, je kunt dan ook door middel van LinkedIn
                reageren.&nbsp;
              </p>
            </div>
          </div>
        </div>

        <div>
          <h4>
            <strong>
              Kan ik bekijken op welke vacatures ik heb gesolliciteerd?
            </strong>
          </h4>
          <div>
            <div>
              <p>
                Ja, dat kan. Log in met je e-mailadres en wachtwoord op
                deBanenSite.nl en klik in het linkermenu op de button
                ‘sollicitaties’. Hier vind je jouw sollicitaties terug.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default FaqPage;
